export const header = {
  homepage: "https://erxcc.dev/",
  title: "EL.",
};

export const about = {
  name: "ERIC",
  role: "Software Developer",
  description:
    "Python backend engineer with 5+ years of experience building automation tools, web scrapers, and API-driven applications, including hands-on use of AI and machine learning in production projects. Strong experience working with data, PostgreSQL, and cloud-hosted systems. I enjoy solving real problems, debugging complex systems, and building efficient, practical solutions. Recently, I’ve been exploring Web3 and AI-powered applications, while continuing to deepen my skills in JavaScript/TypeScript and React to deliver more polished full-stack products.",
  resume:
    "https://rxresu.me/erxcc/python-developer",
  social: {
    linkedin: "https://www.linkedin.com/in/eric-lin1/",
    github: "https://github.com/erxcc",
  },
};

export const projects = [
  {
    name: "Sharely",
    description: "Sharely is a full-stack SaaS application for planning and sharing romantic date itineraries. Users build multi-day plans with activities, times and locations, choose from nine keepsake-style themes, and share them with their partner through a single link that feels like a gift, complete with calendar export. Features Clerk authentication, Stripe one-time unlocks, and location geocoding.",
    stack: ["Python", "FastAPI", "PostgreSQL", "SQLAlchemy", "React", "TypeScript", "Vite", "TailwindCSS", "Clerk", "Stripe", "Railway"],
    livePreview: "https://sharely.erxcc.com/",
  },
  {
    name: "Luna Rewards",
    description: "A full-stack, multi-tenant SaaS loyalty platform designed to replace paper punch cards for small businesses. Features a comprehensive merchant dashboard for real-time customer analytics, team management with role-based permissions, and a zero-friction mobile experience for customers to track stamps and unlock rewards.",
    stack: ["Python", "FastAPI", "PostgreSQL", "React", "TypeScript", "TailwindCSS", "MongoDB", "Vercel"],
    livePreview: "https://getluna.co.uk",
  },
  {
    name: "Summo",
    description: "Summo is a web application that allows users to upload youtube videos and get a summary of the video. We use youtube's API to get the video data and then use OpenAI's API to generate a summary and flashcards of the video.",
    stack: ["Python", "Flask", "OpenAI", "Youtube API", "React", "TailwindCSS", "HTML", "Vercel"],
    livePreview: "https://summo.erxcc.com/",
  },
  {
    name: "Wrapped Now",
    description: "Wrapped Now is a web application that provides real-time Spotify listening analytics. Users can log in with their Spotify account to instantly view their personalized music insights, top artists, genre breakdowns, and listening patterns. Unlike Spotify Wrapped which is yearly, Wrapped Now gives you your music journey analytics anytime, presented through a beautiful interface with dark/light mode support.",
    stack: ["Python", "Flask", "Spotify API", "CSS", "React", "JavaScript"],
    livePreview: "https://wrappednow.xyz/"
  },
  {
    name: "TheSoleHub",
    description:
      "TheSoleHub is a sneaker consignment platform for sneaker stores, designed to help increase inventory quantity without the need to invest heavily in purchasing stock. Utilising Shopify's API, we are able to auto consign orders to sellers and notify sellers through email notifications, and provide a platform for sellers to manage their inventory.",
    stack: ["Python", "Flask", "MongoDB", "smtplib", "Threading", "APIs", "HTML", "CSS", "JavaScript"],
    livePreview: "https://thesolehub.erxcc.com/",
  },
  {
    name: "TheUnityGroup",
    description:
      "TheUnityGroup is a platform to help Church's and Mosques generate donations links and manage their donations. Additional features such as mass email and sms notifications allows Church's and Mosques to keep their members up to date with events and news.",
    stack: ["Python", "Stripe", "HTML", "CSS", "JavaScript", "React"],
    livePreview: "https://theunitygroup.erxcc.com/",
  },
  {
    name: "EngageX",
    description:
      "EngageX helps automote tasks on X (Twitter). Without the need to purchase X's API, EngageX allows users to automate their Twitter accounts with ease. EngageX is CLI and offers a variety of features, including auto-follow, auto-like, auto-retweet, and auto-reply. With EngageX, users can save time, increase engagement, and grow their audience on X.",
    stack: ["Python", "OpenAI", "Requests", "Threading", "APIs", "CLI"],
    livePreview: "https://engagex.erxcc.com/",
  },
  {
    name: "Solana Automation Software",
    description:
      "A CLI software built to snipe memecoins on the Solana blockchain. Provding our own in-house build monitors to monitor all memecoins on chain, users can snipe memecoins with their own custom filters. We also provide features to allow users to monitor other platforms such as X, Telegram and Discord.",
    stack: ["Python", "GoLang", "Requests", "Solana", "RPC", "Selenium", "Threading", "APIs", "CLI"],
    livePreview: "https://github.com/erxcc",
  },
  {
    name: "Nova Chat Bot",
    description:
      "Nova Chat Bot is an interactive chat bot that helps users with their queries. Nova is powered by OpenAI's API, however, this is currently disabled due to high costs. Nova was developed to help develop my frontend and JavaScript skills.",
    stack: ["JavaScript", "CSS", "HTML", "Netlify"],
    livePreview: "https://novachat.erxcc.com/",
  },
  {
    name: "Movie Match",
    description:
      "Movie Match is a user-friendly web application that allows movie enthusiasts to search and discover films with ease. Movie Match uses the TMDB api to get real time data. Movie Match aims to be a go-to platform for anyone looking to explore their next favorite film.",
    stack: ["Python", "Django", "APIs", "HTML", "CSS", "JavaScript"],
    livePreview: "https://moviematch.erxcc.com/",
  },
  {
    name: "Feeling Foodie",
    description:
      "Feeling Foodie is an interactive web application that helps users explore various cuisines and discover new recipes based on their preferences. The platform allows users to browse through different types of cuisines, read about them, and find corresponding recipes to cook at home.",
    stack: ["Python", "Flask", "JavaScript", "CSS", "HTML", "APIs", "Render"],
    livePreview: "https://feelingfoodie.erxcc.com/",
  },

];

export const skills = [
  "Python",
  "PyTorch",
  "OpenAI",
  "Data Analysis",
  "Flask",
  "FastAPI",
  "Django",
  "Requests",
  "Web Scraping",
  "Selenium",
  "Threading",
  "APIs",
  "CLI",
  "VS Code",
  "Discord.py",
  "MongoDB",
  "PostgreSQL",
  "GitHub",
  "HTML",
  "CSS",
  "JavaScript",
  "GoLang",
  "AWS",
  "MySQL",
  "Playwright",
  "PyTest",
  "Azure",
  "GCP",
  "Docker",
  "CI/CD Pipelines",
];

export const contact = {
  email: "ericlin246@outlook.com",
};
